import styled, { createGlobalStyle, css } from "styled-components";
import TypographyFunctions from "./TypographyFunctions";
import { ModalStyleProps } from "./ui-components/modal";

export const GlobalStyle = createGlobalStyle`
  /* cyrillic-ext */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZJhiJ-Ek-_EeAmM.woff2) format('woff2');
    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
  }
  /* cyrillic */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZthiJ-Ek-_EeAmM.woff2) format('woff2');
    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  /* greek-ext */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZNhiJ-Ek-_EeAmM.woff2) format('woff2');
    unicode-range: U+1F00-1FFF;
  }
  /* greek */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZxhiJ-Ek-_EeAmM.woff2) format('woff2');
    unicode-range: U+0370-03FF;
  }
  /* vietnamese */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZBhiJ-Ek-_EeAmM.woff2) format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZFhiJ-Ek-_EeAmM.woff2) format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hiJ-Ek-_EeA.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  html,
  body {
    padding: 0;
    margin: 0;
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
  }

  * {
    font-family: "Inter";
  }
  
  a {
    color: inherit !important;
    text-decoration: none !important;
  }
  
  p {
    margin: 0;
  }
  h1 {
    margin: 0
  }
  
  * {
    box-sizing: border-box;
  }
  
  .App {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    padding: 0;
    margin: 0;
  }

  .flex {
    display: flex;
  }

  .flex--1 {
    flex: 1 !important;
  }

  .flex--column {
    display: flex;
    flex-direction: column;
  }

  .flex--row {
    display: flex;
    flex-direction: row;
  }

  .all--center {
    align-items: center;
    justify-content: center;
  }
  .text--align {
    text-align: center;
  }

  .pointer {
    cursor: pointer;
  }

  .default-cursor {
    cursor: default !important;
  }

  .react-flow__attribution {
    display: none;
  }

  .file__upload-text {
    color: #731DCF;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }
  
  
  html {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: transparent;
    }
    
    html,
    body {
      padding: 0;
      margin: 0;
      width: 100vw;
      height: 100vh;
      overflow-x: hidden;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      font-family: "Jost",-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,Liberation Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    }
    
    * {
      box-sizing: border-box;
    }

    .iconLeft > svg {
      cursor: unset !important;
    }
    
    svg {
      cursor: pointer;
      @extend .user-select-none;
    }
    
    .flex {
      display: flex;
    }
    
    .text-line-clamp-2 {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-hyphens: auto;
      hyphens: auto;
      word-break: break-word;
    }

    //header with max z-index
    .sticky-top {
      z-index: 9999 !important;
    }
    .text-brandMain {color: ${(props) => props.theme.colors.brandMain};}
    .ml-auto,.mx-auto{margin-left:auto!important;}
    ${(props) => TypographyFunctions(props)}
    
    .title-large {
      ${(props) => props.theme.fonts.titleLarge}
    }

    .title-medium {
      ${(props) => props.theme.fonts.titleMedium}
    }

    .title-regular {
      ${(props) => props.theme.fonts.titleRegular}
    }

    .title-small {
      ${(props) => props.theme.fonts.titleSmall}
    }

    .display {
      ${(props) => props.theme.fonts.display}
    }

    .body-primary {
      ${(props) => props.theme.fonts.bodyPrimary}
    }

    .body-secondary {
      ${(props) => props.theme.fonts.bodySecondary}
    }

    .button-large {
      ${(props) => props.theme.fonts.buttonLarge}
    }

    .button-regular {
      ${(props) => props.theme.fonts.buttonRegular}
    }

    .button-small {
      ${(props) => props.theme.fonts.buttonSmall}
    }
    
    .body-caption {
      ${(props) => props.theme.fonts.bodyCaption}
    }

    .body-tiny {
      ${(props) => props.theme.fonts.bodyTiny}
    }
    .mx-17 {
      margin-left: 17px;
      margin-right: 17px;
    }

    .align--items--center {
      align-items: center;
    }
    .align--items--start {
      align-items: flex-start;
    }
    .text--center {
      text-align: center;
    }

    .w--full {
      width: 100%;
    }

    .flex {
      display: flex;
    }

    .flex--1 {
      flex: 1 !important;
    }

    .flex--column {
      flex-direction: column;
    }

    .flex--row {
      flex-direction: row;
    }

    .margin--top--8 {
      margin-top: 8px;
    }

    .margin--right--4 {
      margin-right: 4px;
    }

    .margin--x--2 {
      margin-left: 2px;
      margin-right: 2px;
    }

    .margin-top-4 {
      margin-top: 4px;
    }

    .margin--top--4 {
      margin-top: 4px;
    }

    .margin--top--24 {
      margin-top: 24px;
    }

    .margin--bottom--4 {
      margin-bottom: 4px;
    }
    
    .m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}.stretched-link:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:"";background-color:transparent}.text-justify{text-align:justify!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media(min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}.visible{visibility:visible!important}.invisible{visibility:hidden!important}.sticky-top{z-index:9999!important}
    .d-flex{display:flex!important}.d-inline-flex{display:inline-flex!important}.flex-row{flex-direction:row!important}.flex-column{flex-direction:column!important}.flex-row-reverse{flex-direction:row-reverse!important}.flex-column-reverse{flex-direction:column-reverse!important}.flex-wrap{flex-wrap:wrap!important}.flex-nowrap{flex-wrap:nowrap!important}.flex-wrap-reverse{flex-wrap:wrap-reverse!important}.flex-fill{flex:1 1 auto!important}.flex-grow-0{flex-grow:0!important}.flex-grow-1{flex-grow:1!important}.flex-shrink-0{flex-shrink:0!important}.flex-shrink-1{flex-shrink:1!important}.justify-content-start{justify-content:flex-start!important}.justify-content-end{justify-content:flex-end!important}.justify-content-center{justify-content:center!important}.justify-content-between{justify-content:space-between!important}.justify-content-around{justify-content:space-around!important}.align-items-start{align-items:flex-start!important}.align-items-end{align-items:flex-end!important}.align-items-center{align-items:center!important}.align-items-baseline{align-items:baseline!important}.align-items-stretch{align-items:stretch!important}.align-content-start{align-content:flex-start!important}.align-content-end{align-content:flex-end!important}.align-content-center{align-content:center!important}.align-content-between{align-content:space-between!important}.align-content-around{align-content:space-around!important}.align-content-stretch{align-content:stretch!important}.align-self-auto{align-self:auto!important}.align-self-start{align-self:flex-start!important}.align-self-end{align-self:flex-end!important}.align-self-center{align-self:center!important}.align-self-baseline{align-self:baseline!important}.align-self-stretch{align-self:stretch!important}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{top:0}.fixed-bottom,.fixed-top{position:fixed;right:0;left:0;z-index:1030}.fixed-bottom{bottom:0}.w-100{width:100%!important}.w-auto{width:auto!important}
    .mb-4,.my-4{margin-bottom: 1.5rem!important}.mt-2,.my-2{ margin-top: .5rem!important;}


    // customization for react flow
    .react-flow__node-CustomNode {
      width: 280px;
      border-radius: 8px;
      /* box-shadow: 0px 2px 8px rgb(0 0 0 / 12%); */
    }

    .react-flow__node-CustomNode[data-id^='S'] {
      z-index: 98 !important;
      background-color: #FFF7E5 !important;
    }

    .react-flow__node-CustomNode[data-id^='S']:hover {
      z-index: 100 !important;
    }
    
    .react-flow__node-selectorNode {
      font-size: 12px;
      background: #eee;
      border-radius: 5px;
      text-align: center;
    }
  
    .react-flow__handle-right {
      top: unset !important;
    }

    .react-flow__controls {
      display: flex;
      flex-direction: row;
      box-shadow: none;
      gap: 16px;
      left: 44%;
      button {
        width: 40px;
        height: 40px;
        box-shadow: 0px 4px 12px rgb(0 0 0 / 12%);
        border-radius: 50%;
        border-bottom: none;
      }
    }

    .icon-wrapper {
      height: 32px;
      width: 32px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .customNode__childNodes {
      position: relative !important;
    }

    /* Set content for sizes */
    .ql-size-small {
      font-size: 11px !important;
    }
    .ql-size-default {
      font-size: 14px !important;
    }
    .ql-size-large {
      font-size: 20px !important;
    }
    .ql-size-huge {
      font-size: 28px !important;
    }
  
`;

export const ModalStyle = styled.div<ModalStyleProps>`
  font-family: "Inter";
  min-width: ${(props) => props.minWidth || 400}px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 24px;
  max-width: ${(props) => props.maxWidth || 400}px;
  width: 1080px;
  margin: auto;

  .cursor-pointer {
    cursor: pointer;
  }

  .tool__box {
    position: relative !important;
    right: 0 !important;
  }

  .modal {
    &__heading {
      display: flex;
      justify-content: space-between;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      /* identical to box height, or 120% */

      font-feature-settings:
        "tnum" on,
        "lnum" on,
        "case" on,
        "ss04" on;

      /* content/$color-content-primary */

      color: #212121;
      padding-bottom: 8px;
    }
  }
`;
